import React, { Component } from 'react'

export default class Timeline extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                
                <h2 className="colorlib-heading animate-box" style={{ color: "rgb(67, 197, 158)"}}>Portfolio</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div >
                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft" >
                    
                    <div className="timeline-label" style={{display: "flex", flexDirection: "column"}}>
                      <h2 style={{ color: "#f0c14b"}}>AMAZONE ClONE</h2>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "space-evenly"}}>
                          <img src="images/amazon.png" style={{width: "20vw", objectFit: "contain" }} />
                        <button style={{ margin: "10px", backgroundColor: "rgb(67, 197, 158)", border: "none"}}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://clone-c4606.web.app/" target="_blank">LIVE APP</a>
                        </button>
                        <button style={{ backgroundColor: "rgb(67, 197, 158)", border: "none"}}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://github.com/jadibdev/Amazon__Clone" target="_blank">SOURCE CODE</a>
                        </button>
                        </div>
                      <img src="images/amazon_deployed.png" style={{ width: "100%", objectFit: "contain" }} />
                    </div>
                    
                  </article>
                  


                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft" >
                    <div className="timeline-label" style={{ display: "flex", flexDirection: "column", marginTop: "120px" }}>
                      <h2 style={{ color: "#fe3d71" }}>TINDER ClONE</h2>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                        <img src="images/tinder.png" style={{ width: "20vw", objectFit: "contain" }} />
                        <button style={{ margin: "10px", backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://celebrity-tinder-2532b.web.app/" target="_blank">LIVE APP</a>
                        </button>
                        <button style={{ backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://github.com/jadibdev/Celebrity_Tinder" target="_blank">SOURCE CODE</a>
                        </button>
                      </div>
                      <div style={{display: "flex", justifyContent: "space-evenly"}}>
                        <img src="images/beyonce.png" style={{ width: "20vw", objectFit: "contain" }} />
                      
                        <img src="images/neymar.png" style={{ width: "20vw", objectFit: "contain" }} />
                      </div>
                    </div>
                  </article>

                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft" >
                    <div className="timeline-label" style={{ display: "flex", flexDirection: "column", marginTop: "120px" }}>
                      <h2 style={{ color: "#979797" }}>Apple ClONE</h2>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                        <img src="images/apple-logo1.png" style={{ width: "7vw", objectFit: "contain"}} />
                        <button style={{ margin: "10px", backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://serene-turing-1162d4.netlify.app/#" target="_blank">LIVE SITE</a>
                        </button>
                        <button style={{ backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://github.com/jadibdev/codifyAcademy-wk4-responsiveApple" target="_blank">SOURCE CODE</a>
                        </button>
                      </div>
                        <img src="images/apple.png" style={{ width: "100%", objectFit: "contain", marginTop: "20px"}} />
                    </div>
                  </article>

                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft" >
                    <div className="timeline-label" style={{ display: "flex", flexDirection: "column", marginTop: "120px" }}>
                      <h2 style={{ color: "#3c3b6e" }}>WHITE HOUSE ClONE</h2>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                        <img src="images/white__houseLogo.svg" style={{ width: "7vw", objectFit: "contain" }} />
                        <button style={{ margin: "10px", backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://quizzical-mccarthy-d0f40f.netlify.app/" target="_blank">LIVE SITE</a>
                        </button>
                        <button style={{ backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://github.com/jadibdev/White-House-Rebuild" target="_blank">SOURCE CODE</a>
                        </button>
                      </div>
                      <img src="images/white__house.png" style={{ width: "100%", objectFit: "contain", marginTop: "20px" }} />
                    </div>
                  </article>

                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft" >
                    <div className="timeline-label" style={{ display: "flex", flexDirection: "column", marginTop: "120px" }}>
                      <h2 style={{ color: "#3c3b6e" }}>LG UI FOR GYM SCREENS</h2>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                        <img src="images/LG1.png" style={{ width: "14vw", objectFit: "contain" }} />
                        <button style={{ margin: "10px", backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://upbeat-allen-d3f5dc.netlify.app/" target="_blank">LIVE SITE</a>
                        </button>
                        <button style={{ backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://github.com/jadibdev/LG_mobile-desktop_solution" target="_blank">SOURCE CODE</a>
                        </button>
                      </div>
                      <img src="images/LG.png" style={{ width: "100%", objectFit: "contain", marginTop: "20px" }} />
                    </div>
                  </article>

                  <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft" >
                    <div className="timeline-label" style={{ display: "flex", flexDirection: "column", marginTop: "120px" }}>
                      <h2 style={{ color: "#E50914" }}>NETFLIX ClONE</h2>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                        <img src="images/netflix.png" style={{ width: "14vw", objectFit: "contain" }} />
                        <button style={{ margin: "10px", backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://netflix-clone-bc6a9.web.app/" target="_blank">LIVE SITE</a>
                        </button>
                        <button style={{ backgroundColor: "rgb(67, 197, 158)", border: "none" }}>
                          <a style={{ color: "white", padding: "20px 10px 20px 10px" }} href="https://github.com/jadibdev/Netflix-Clone" target="_blank">SOURCE CODE</a>
                        </button>
                      </div>
                      <img src="images/netflix_cover.png" style={{ width: "100%", objectFit: "contain", marginTop: "20px" }} />
                    </div>
                  </article>


                  
                  <article className="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
